import PageHeader from '../../components/PageHeader/PageHeader';
import Toolbar from '../../components/Toolbar/Toolbar';
import React, { useState, useEffect, useRef } from 'react';
import DataTable from 'react-data-table-component';
import { IoTrashOutline } from "react-icons/io5";
import { LuPencilLine } from "react-icons/lu";
import AgregarMedida from './AgregarMedida';
import EditarMedida from './EditarMedida';
import {urlApiProd} from '../utiles';

const Medidas = () => {
    const [dataMedidas, setDataMedidas] = useState([]);
    const firstRender = useRef(true);
    const [showAgregar, setShowAgregar] = useState(false);
    const [showEditar, setShowEditar] = useState(false);
    const [selected, setSelected] = useState(null);
    const [filterText, setFilterText] = useState('');
    const [filteredData, setFilteredData] = useState([]);

    const fetchData = async () => {
        const token = localStorage.getItem('token'); // Obtener token de autenticación
        try {
            const medidaResponse = await fetch(`${urlApiProd}/medidas`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            if (medidaResponse.status === 401) {
                throw new Error('Unauthorized');
            }
            const medidaData = await medidaResponse.json();
            setDataMedidas(medidaData);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        if (firstRender.current) {
            fetchData();
            firstRender.current = false;
        }
    }, []);

    useEffect(() => {
        if (Array.isArray(dataMedidas)) {
            const filtered = dataMedidas.filter((row) =>
                Object.values(row).some((value) =>
                    value.toString().toLowerCase().includes(filterText.toLowerCase())
                )
            );
            setFilteredData(filtered);
        }
    }, [dataMedidas, filterText]);

    const columns = [
        {
            name: 'Editar',
            cell: (row) => (
                <button className='btn btn-outline-primary' onClick={() => handleEditar(row)}>
                    <LuPencilLine />
                </button>
            ),
        },
        {
            name: 'Medida',
            selector: row => row.medida,
        },
        {
            name: 'Medida Factura',
            selector: row => row.ancho + ' x ' + row.largo,
        },
        {
            name: 'Realsize',
            selector: row => row.anchor + ' x ' + row.largor,
        },
        {
            name: 'Pulgadas',
            selector: row => row.anchop + ' x ' + row.largop,
        },
        {
            name: 'Plies',
            selector: row => row.plies,
        },
        {
            name: 'Espesores',
            selector: row => row.espesor.length, // Mostrar la cantidad de espesores
        },
        {
            name: 'Eliminar',
            cell: (row) => (
                <button
                    className='btn btn-outline-danger'
                    onClick={() => {
                        if (window.confirm('¿Estas seguro?')) {
                            handleEliminar(row.id_medida);
                        }
                    }}
                >
                    <IoTrashOutline />
                </button>
            ),
            ignoreRowClick: true,
        },
    ];

    const handleAgregar = () => {
        setShowAgregar(true);
    };

    const handleEditar = (medida) => {
        setSelected(medida);
        setShowEditar(true);
    };

    const handleSaveEditar = (edited) => {
        const token = localStorage.getItem('token'); // Obtener token de autenticación
        fetch(`${urlApiProd}/editarmedida/${edited.id_medida}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(edited),
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Error al actualizar datos');
            }
            return response.json();
        })
        .then(data => {
            alert('Datos actualizados exitosamente');
            fetchData(); // Refrescar los datos después de la edición
        })
        .catch(error => {
            console.error('Error:', error);
        });
    };

    const handleCloseEditar = () => {
        setSelected(null);
        setShowEditar(false);
    };

    const handleEliminar = (idAEliminar) => {
        const token = localStorage.getItem('token'); // Obtener token de autenticación
        fetch(`${urlApiProd}/eliminarmedida/${idAEliminar}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
        })
        .then(async response => {
            if (response.ok) {
                alert('Datos Eliminados Correctamente.');
                fetchData();
            } else {
                const errorData = await response.json();
                alert('Error al intentar eliminar datos: ' + (errorData.error || 'Error desconocido'));
            }
        })
        .catch(error => {
            console.error('Error de red:', error);
            alert('Error de red al intentar eliminar datos.');
        });
    };

    return (
        <div className='container-fluid ui-page'>
            <PageHeader
                eyebrow="Registros"
                title="Medidas"
                descripcion="Catálogo de medidas de los productos."
                actions={
                    <button type="button" className="ui-btn ui-btn-primary" onClick={handleAgregar}>Agregar Medida</button>
                }
            />
            <div className='card'>
                <div className='card-body mb-2'>
                    <Toolbar
                        left={
                            <input
                                type="text"
                                placeholder="Buscar..."
                                value={filterText}
                                onChange={(e) => setFilterText(e.target.value)}
                                className='form-control'
                            />
                        }
                    />
                    
                    {showAgregar && <AgregarMedida cerrar={() => setShowAgregar(false)} />}
                    <div className="card">
                        <div className="card-body">
                            <DataTable
                                columns={columns}
                                data={filteredData}
                                noHeader
                                responsive
                                pagination
                                highlightOnHover
                            />
                        </div>
                    </div>
                    {selected && showEditar && (
                        <EditarMedida
                            medida={selected}
                            cerrar={handleCloseEditar}
                            guardar={handleSaveEditar}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default Medidas;
